import { render, staticRenderFns } from "./PromotionStepECoupon.vue?vue&type=template&id=4f488bc2&scoped=true&"
import script from "./PromotionStepECoupon.vue?vue&type=script&lang=js&"
export * from "./PromotionStepECoupon.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepECoupon.vue?vue&type=style&index=0&id=4f488bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f488bc2",
  null
  
)

export default component.exports